<template>
  <div class="item">
    <div class="top">
      <div><span></span></div>
      <div>{{ (company && company.companyName) || "未知公司" }}</div>
    </div>
    <div class="bottom">
      <div class="bottom-item">
        <div>
          <span>企业税号：</span>
          <span>{{ (company && company.creditCode) || "-" }}</span>
        </div>
        <div>
          <span>经营状态：</span>
          <span>{{ (company && company.businessStatus) || "-" }}</span>
        </div>
        <div>
          <span>企业类型：</span>
          <span>{{ (company && company.companyType) || "-" }}</span>
        </div>

        <div>
          <span>所属行业：</span>
          <span
            v-if="company.industry1 || company.industry2 || company.industry3"
            >{{
              company.industry1 +
              "，" +
              company.industry2 +
              "，" +
              company.industry3
            }}</span
          >
          <span v-else>-</span>
        </div>
        <div>
          <span>注册地址：</span>
          <span>{{ (company && company.registeredAddress) || "-" }}</span>
        </div>
      </div>
      <div class="bottom-item">
        <van-button
          type="primary"
          size="normal"
          @click="$emit('convert', company && company.id)"
        >
          转为客户
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from "vant";

export default {
  name: "CompanyItem",

  components: {
    [Button.name]: Button,
  },

  props: {
    company: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  created() {},
};
</script>

<style scoped>
.item {
  padding: 4vw;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: white;
  border-radius: 12px;
}

/* 企业卡片顶部 */
.item .top {
  padding-bottom: 2vw;
  display: flex;
  gap: 8px;
  font-size: 4.6vw;
  font-weight: 600;
  align-items: center;
}

.item .top div:nth-of-type(1) {
  height: 100%;
  display: flex;
  align-items: center;
}

.item .top div:nth-of-type(1) span {
  display: block;
  width: 1vw;
  height: 3.2vw;
  background-color: #4988fd;
  border-radius: 2px;
}

/* 企业卡片底部 */
.item .bottom {
  display: grid;
  gap: 3vw;
}

/* 企业信息区域 */
.item .bottom-item:nth-of-type(1) {
  display: grid;
  gap: 2vw;
}

.item .bottom-item:nth-of-type(1) div {
  display: grid;
  grid-template-columns: 18vw auto;
  font-size: 3.6vw;
}

.item .bottom-item:nth-of-type(1) div span:nth-of-type(1) {
  color: #6d6d6d;
}

/* 转为客户按钮 */
.bottom-item .van-button {
  width: 100%;
  /* height: 9vw; */
  padding: 0;
  background-image: linear-gradient(90deg, #3796ff 0%, #1b5dd9 100%);
  color: white;
  border-radius: 8px;
  font-weight: 600;
  font-size: 4vw;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/view/customerCenter/module/accurateSearch/components/CompanyItem.vue